import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription, Subject, Observable } from 'rxjs/Rx';

import { CommonService } from '../../services/common.service';
import { UtilityService } from '../../services/utility.service';
import { ModalService } from '../../services/modal.service';
import { AuthService } from '../../services/authentication.service';
import { AppStateService } from '../../services/app-state.service';
import { SocketService } from '../../services/socket.service';
import { PreloaderService } from '../../services/preloader.service';

import { AccountApi, ProjectApi, RecordTypeApi, ReleaseNotesApi, WorkerApi, UsersApi, SurveyAnalyticsApi,CustomerCsatApi } from '../../sdk';
import { environment } from '../../../environments/environment';
import { MaintenanceScheduleApi } from 'shared/sdk/services/custom/MaintenanceSchedule';
import { MaintenanceScheduleInterface, TrainingPlanAssignmentApi } from 'shared/sdk';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import axios from 'axios';
import { MessageNotificationSocketService } from 'shared/services/message-notification-socket.service';
import { FaviconBadgeService } from 'shared/services/favicon-badge.service';

@Component({
    selector: 'app-nav-header',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
    providers: [ModalService, UtilityService]
})

export class NavigationComponent implements OnInit, OnDestroy {

    user: any;
    imgpath: any;
    accessType = '';
    webTitle = 'ServiceO';
    notification: number;
    viewType = '';
    render = '/pms';
    toggleSwitch: any;
    private subscription: Subscription;
    private subscription1: Subscription;
    @ViewChild('openModel') openModel: ElementRef;
    @ViewChild('profileOpenModal') profileOpenModal: ElementRef;
    @ViewChild('maintenanceModal') maintenanceModal: ElementRef;
    @ViewChild('createTaskModal') createTaskModal: ElementRef;
    @ViewChild('createFeedbackModal') createFeedbackModal: ElementRef;
    @ViewChild('csatOpenModel') csatOpenModel: ElementRef;
    @ViewChild('fteSTMOpenModel') fteSTMOpenModel: ElementRef;
    @ViewChild('trainingOpenModel') trainingOpenModel: ElementRef;
    @ViewChild('userPreferencesModel') userPreferencesModel: ElementRef;

    accounts = [];
    workersList = [];
    allWorkersList = [];
    vendor: any;
    tableData = [];
    noRecords: any;
    itemsPerPage = 10;
    itemsPerBatch = 100;
    totalCount: Number = 0;

    loadingIndicator: any;
    recordTypeId = '0121a000000QaUYAA0';
    txtAccountName = '';
    public keyUp = new Subject<string>();
    userTypeSlug = '';
    viewAsTypeName: string;
    programSelection = false;
    partnerInfo: any;
    viewAsInfo: any;
    workerType = '';
    isMaintenanceButtonVisible = false;
    maintenanceAlertColor = false;
    isMagicLink = false;
    hideNotification: any;
    isVendorWorkerSelected = false;
    vendorAccessType: any;
    viewAsVendor = false;
    isVendorView = false;
    isNgo = false;
    partnerIsAdmin = false;
    openedDialog = false;
    isViewAsPMS = false;
    isViewAsPMSA = false;
    newCountReleaseNotes = 0;
    showReleaseCounts: boolean = false;
    public workerKeyUp = new Subject<string>();
    workerTableData: any= [];
    workerTxtAccountName= '';
    showVendorListing = true;
    showWorkerListing= false;
    totalWorkerCount = 0;
    wikiURL = 'https://wiki.serviceglobal.com/wiki/serviceo/view/WebApp/'
    workerIDOrEmail=[];
    csatUrl = '';
    csatName = ''
    csatText = ''
    fteStmMessage = ''
    surveyData : any;
    isFTELogin = false;
    isVmsa = false;
    trainingData : any;
    accountSfcdId:any;
    filteredItems = [];
    localFilters: any = {};
    accountNameLabel = '';
    modalRef: NgbModalRef;
    showConsentModal = false;

    constructor(
        private _location: Location,
        private _cdRef: ChangeDetectorRef,
        private _router: Router,
        private authService: AuthService,
        private _preloader: PreloaderService,
        private _appState: AppStateService,
        private _utilityService: UtilityService,
        private commonService: CommonService,
        private _modalService: ModalService,
        private _socketService: SocketService,
        private _messageNotificationSocketService: MessageNotificationSocketService,
        private _faviconBadgeService: FaviconBadgeService,
        private accountApi: AccountApi,
        private workerApi: WorkerApi,
        private _commonService: CommonService,
        private _recordType: RecordTypeApi,
        private _projectApi: ProjectApi,
        private _maintenanceApi: MaintenanceScheduleApi,
        private _releaseNotesApi: ReleaseNotesApi,
        private _usersApi: UsersApi,
        private _surveyAnalyticsApi : SurveyAnalyticsApi,
        private _customerCsatApi: CustomerCsatApi,
        private _trainingPlanAssignmentApi: TrainingPlanAssignmentApi,
        private _modalServicen: NgbModal



    ) { }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this._router.url.indexOf('pms') !== -1) {
            localStorage.removeItem('ImpersonationId');
            this._appState.setNavAsVendor(null);
        }
    }

    ngOnInit() {
        const viewAsInfo = JSON.parse(localStorage.getItem('viewAsInfo'));
        this.isVendorView = (viewAsInfo && viewAsInfo.viewAsType === 'Vendor');
        this.isViewAsPMS = (viewAsInfo && viewAsInfo.viewAsType === 'Partner');
        this.isViewAsPMSA = (viewAsInfo && viewAsInfo.viewAsType === 'Partner' && viewAsInfo.isAdmin);
        this.hideNotification = environment.hideNotification;
        this.imgpath = environment.baseUrl + '/' + environment.apiVersion;
        this.accessType = this._appState.getAccessType();
        const appData = JSON.parse(localStorage.getItem('appData'));
        this.isMagicLink = appData.user && appData.user.isMagiclinkTest ? appData.user.isMagiclinkTest : false;
        this.isNgo = appData.user && appData.user.isNgo ? appData.user.isNgo : false;
        this.userTypeSlug = this._appState.getUserTypeSlug();
        this.isVmsa =  (this.accessType == 'vendor' && this.userTypeSlug == 'admin') || (this.isVendorView && viewAsInfo.userTypeSlug == 'admin');
        this.isFTELogin = appData.user && appData.user.workers.length && appData.user.workers[0].is_FTE_Worker__c ? appData.user.workers[0].is_FTE_Worker__c : false;
        if (this.accessType === 'internal') {
            this.CheckMaintenanceModal();
        }

        if (appData.user && appData.user.workers.length && appData.user.workers[0].customerCSAT && appData.user.workers[0].customerCSAT.length && appData.user.workers[0].customerCSAT[0].sfdcId) {
            if (appData.user.workers[0].customerCSAT[0].quiz && appData.user.workers[0].customerCSAT[0].quiz.Name) {
                let quizText = appData.user.workers[0].customerCSAT[0].quiz.QuizText ? appData.user.workers[0].customerCSAT[0].quiz.QuizText : '';
                this.csatUrl = `https://ironsystems--fullsb.sandbox.my.salesforce-sites.com/PMS/apex/SurveyLogin?id=${appData.user.workers[0].customerCSAT[0].sfdcId}&src=Serviceo-Web&wid=${appData.user.workers[0].Dispatch_Worker_num__c}`;
                this.csatName = appData.user.workers[0].customerCSAT[0].quiz.Name;
                this.csatText = quizText.replace('surveylink', `<a id="clickSurvey" href="javascript:void(0)"> ${this.csatName}</a>`);

                if (localStorage.getItem('csatModalViewed') !== 'true') {
                    this.openCsatModal();

                    const reqObj = {
                        'workerSfdcId': appData.user.workers[0].sfdcId,
                        'wlmsSurveySfdcId': appData.user.workers[0].customerCSAT[0].sfdcId,
                        'popupDate': new Date()
                    }

                    this.createOrUpdateSurvey(reqObj, 'open');

                }

            }
        }

                if (appData.user && appData.user.workers.length && appData.user.workers[0].is_FTE_Worker__c && appData.user.workers[0].customerCSAT.length == 0 && appData.user.popup && appData.user.popup.enabled && new Date(appData.user.popup.expDate) > new Date() ) {
            this.fteStmMessage = appData.user.popup && appData.user.popup.message;
            
            if (localStorage.getItem('fteSTMViewed') !== 'true') {
            this.openfteSTMModal();
            }

        }
          if (localStorage.getItem('trainingModalViewed') !== 'true') {
            this.checkUserTrainingPopup(appData.user);
        }

        const prefs = appData.user.preferences || {};
        const requiredKeys = ['sms', 'whatsapp'];
        const allKeysExist = requiredKeys.every(
            key => key in prefs
        );
        if (!allKeysExist && localStorage.getItem('userPreferenceModalDismissed') !== 'true') {
            this.checkProfileSettingPreferencesPopup();
        }


        // console.log(this.userTypeSlug)
        // Total notification autoupdate after event
        // this.getNotificationsCount();
        // shared socket client for SO/PO Messaging Console (job-message-console) - single init point
        //this._messageNotificationSocketService.initializeSocket();
        // set current view name
        this.setCurrentView();
        // set home page url
        this.setHomePageUrl();
        // get current user
        this.setCurrentUser();
        // init server side search for account
        this.initAccountSearch();
        //init server side search for worker list
        this.initWorkerSearch();
        // check vendor view
        this.checkVendorView();
        // check if view As mode is active
        this.checkViewAs();
        // get releasenotesCount
        this.getReleaseNotes();
        console.log('isVMSA', this.isVmsa);
        this.messageNotificationCount();
    }

    createOrUpdateSurvey(data,type) {
        this._surveyAnalyticsApi.upsert(data).subscribe(
            res => {
                if(res){
                    this.surveyData = res;
                    if(type != 'closed'){
                    const reqObj = {
                        csatId: data.wlmsSurveySfdcId,
                        popupType: type
                      }

                    this._customerCsatApi.updateCsat(reqObj).subscribe((res: any) => {
                       console.log('customer Cast Update>>>', res);
                      }, err => {
                        console.log(err);
                      })
                    }


                }
                
            },
            err => {
               console.log('error', err)
            })
    }

    checkUserTrainingPopup(user) {
        if (user && user.sfdcId) {
            const trainingUrl = (this.accessType === 'internal') ? environment.mspUrl + 'app/training' : environment.communityUrl + '/app/training';
            const whereObj: any = {
                where: {
                    Trainee__c: user.sfdcId,
                    showTrainingPopup: true,
                    and: [
                        { Status__c: { neq: 'Completed' } },
                        { Status__c: { neq: 'Expired' } }
                    ]
                },
                fields: ['id', 'sfdcId', 'Trainee__c', 'showTrainingPopup', 'Status__c', 'Training_Plan__c', 'createdAt', 'CreatedDate', 'Name','End_Date__c','Start_Date__c',],

                order: 'CreatedDate DESC',
                include: [
                    {
                        relation: 'trainingPlan',
                        scope: {
                            fields: ['Name', 'Description__c', 'createdAt', 'Intro_Video_URL__c', 'sfdcId', 'id', ],
                        }
                    }
                ],
                limit: 1

            }

    this._trainingPlanAssignmentApi.find(whereObj).subscribe(
      res => {
        if (res && res.length && res[0]['trainingPlan'] && res[0]['trainingPlan']['sfdcId']) {
            this.trainingData = res[0];
            this.trainingData['trainingUrl'] = trainingUrl;
          console.log('Training Plan Assignment >>>', res[0]['trainingPlan']['sfdcId']);
            this.openTrainingModal();
        

        }
    });


        }
        
        
    }

    CheckMaintenanceModal() {
        if (localStorage.getItem('maintenanceModalViewed') === 'true') {
            this.isMaintenanceButtonVisible = true;
        }
        if (localStorage.getItem('maintenanceAlertColor') === 'true') {
            this.maintenanceAlertColor = true;
        }
        var filter = {
            where: {
                isActive: true,
                isEnabled: true,
                endDate: { gt: new Date() }
            },
            order: "startDate ASC",
            limit: 1
        }
        this._maintenanceApi.find(filter).subscribe((res: MaintenanceScheduleInterface[]) => {

            if (res && res.length && Object.keys(res[0]).length) {
                let schedule = res[0];

                if (schedule.startDate && schedule.endDate && (new Date(schedule.startDate) < new Date(schedule.endDate))) {
                    let calculatedStartDate = new Date(schedule.startDate);
                    calculatedStartDate = new Date(calculatedStartDate.setHours(calculatedStartDate.getHours() - 48));

                    if (new Date(schedule.endDate) > new Date() && new Date() > new Date(schedule.startDate)) {
                        this.maintenanceAlertColor = true;
                        localStorage.setItem('maintenanceAlertColor', 'true');
                    } else {
                        this.maintenanceAlertColor = false;
                        localStorage.removeItem('maintenanceAlertColor');
                    }

                    if (new Date(schedule.endDate) > new Date() && new Date() > calculatedStartDate) {
                        this.isMaintenanceButtonVisible = true;
                        if (localStorage.getItem('maintenanceModalViewed') !== 'true') {
                            this.openMaintenanceModal();
                        }
                    } else {
                        this.resetMaintenanceModal();
                    }

                } else {
                    this.resetMaintenanceModal();
                }

            } else {
                this.resetMaintenanceModal();
            }

        });
    }

    resetMaintenanceModal() {
        this.isMaintenanceButtonVisible = false;
        this.maintenanceAlertColor = false;
    }

    openMaintenanceModal() {
        this._modalService.open(this.maintenanceModal);
    }

    openCsatModal() {
        this._modalService.open(this.csatOpenModel);
        localStorage.setItem('csatModalViewed', 'true');

    }

    openTrainingModal() {
       // this._modalService.open(this.trainingOpenModel);
        this.modalRef =this._modalServicen.open(this.trainingOpenModel, { size: 'lg' });

        localStorage.setItem('trainingModalViewed', 'true');
    }

    openfteSTMModal() {
        this._modalService.open(this.fteSTMOpenModel);
        localStorage.setItem('fteSTMViewed', 'true');

    }

    checkViewAs() {
        this.viewAsInfo = JSON.parse(localStorage.getItem('viewAsInfo'));
    }

    getNotificationsCount() {
        this.subscription = this._socketService.getCountNotification().subscribe(
            unreadNotification => {
                this.notification = unreadNotification;
            }
        );
    }

    setCurrentView() {
        this.viewType = '';
        if (this._location.path().indexOf('vms') !== -1 || this._location.path().indexOf('app') !== -1) {
            this.viewType = 'vms';
            this.toggleSwitch = { title: 'Switch to PMS', url: '/pms' };
        } else {
            this.viewType = 'pms';
            this.toggleSwitch = { title: 'Switch to VMS', url: '/vms' };
        }
    }

    setHomePageUrl() {
        this.render = this._appState.getHomeUrl();
        if (!this.render || this.render === '') {
            this.render = '/login';
        }
    }

    setCurrentUser() {
        this.commonService.getUserProfile().subscribe(
            userProfile => {
                this.user = userProfile;
            }
        );
        // set user profile
        if (this.user && this.user['id']) {
            this.accessType = this.user['accessType'];
            this.workerType = this.user['workers'] && this.user['workers'].length ? this.user['workers'][0].Worker_Type__c : '';
            this.getProfileImage();
        } else {
            this._appState.getAppState().subscribe(
                data => {
                    if (data && data['user']) {
                        this.accessType = data['user'].accessType;
                        this.user = data['user'];
                        this.workerType = data['user']['workers'] && data['user']['workers'].length ? data['user']['workers'][0].Worker_Type__c : '';
                    }
                    this.getProfileImage();
                }
            );
        }
    }

    getProfileImage() {
        this.setProfile();
        /* to open password modal to indicate user to change password */
        if (this.user.promptPasswordChange) {
            this.openModel.nativeElement.click();
            this.detectChanges();
        }

        if (!this.openedDialog && !this.user.profileImage && !this.user.promptPasswordChange && (this.accessType === 'internal' || this.accessType === 'vendor') && !this.user.skipProfilePic ) {
            this.profileOpenModal.nativeElement.click();
            this.openedDialog = true;
            this.detectChanges();
        }
    }

    setProfile() {
        this.commonService.setUserProfile(this.user);
    }

    detectChanges() {
        if (!this._cdRef['destroyed']) {
            this._cdRef.detectChanges();
        }
    }

    initAccountSearch() {
        const observable = this.keyUp
            .map(value => value['target']['value'].toLowerCase())
            .debounceTime(300)
            // .distinctUntilChanged()
            .flatMap((search) => {
                return Observable.of(search).delay(300);
            })
            .subscribe((data) => {
                if (this.programSelection) {
                    this.getProgramList(0, false);
                } else {
                    if (this.isVendorWorkerSelected) {
                        this.getWorkerList(this.accountSfcdId);
                    } else {
                        this.getAccount(0, false);
                    }

                }
            });
    }

    checkVendorView() {
        this.vendor = null;
        if (this.accessType === 'internal' && (this.viewType === 'vms' || this.viewType === 'pms') && this.isVendorView) {
            if (this.vendor && this.vendor['sfdcId']) {
                this.setVendorView(this.vendor);
            } else {
                const viewAsInfo = JSON.parse(localStorage.getItem('viewAsInfo'));
                console.log("checkVendorView",viewAsInfo)
                this.workerApi.find({
                    where: { Contact__c: viewAsInfo['userSfdcId'] },
                    fields: ['id', 'sfdcId', 'Name', 'Dispatch_Worker_num__c', 'createdAt']
                }).subscribe(result => {
                    if (result && result.length) {
                        if (result && result[0]) {
                            result[0]['Account_Name__c'] = viewAsInfo && viewAsInfo.userObj && viewAsInfo.userObj.Account_Name__c ? viewAsInfo.userObj.Account_Name__c : ''
                            result[0]['workerSubType'] = viewAsInfo && viewAsInfo.workerSubType ? viewAsInfo.workerSubType : ''

                        }
                       this.setVendorView(result[0]);
                    } else {
                        this.setVendorView(null);
                    }
                }, err => {
                    this.setVendorView(null);
                });
            }
        } else {
            this.setVendorView(null);
        }
    }

    setVendorView(vendor) {
        this.vendor = vendor;
        console.log("setVendorView",this.vendor)
        if (vendor) {
            localStorage.setItem('ImpersonationId', vendor['sfdcId']);
        } else {
            localStorage.removeItem('ImpersonationId');
            const filterCondition = JSON.parse(localStorage.getItem('filterCondition'));
            const filterObj = JSON.parse(localStorage.getItem('filterObj'));
            if (filterCondition && filterCondition['Vendor__c']) {
                delete filterCondition['Vendor__c']
                console.log('Removed filterCondition.Vendor__c from localStorage',filterCondition);
                localStorage.setItem('filterCondition', JSON.stringify(filterCondition));
            }

            if (filterObj && filterObj['accounts']) {
               delete filterObj['accounts'];
                localStorage.setItem('filterObj', JSON.stringify(filterObj));
            }
        
        }
        this._appState.setNavAsVendor(this.vendor);
    }

    showVendorView(account) {
        console.log('Selected Account:', account);
        this.accountSfcdId = account['sfdcId'];
        this.getWorkerList(this.accountSfcdId);
        this.txtAccountName = '';
        //this.workerTxtAccountName = '';
        this.accountNameLabel = account['Name'];
    }


    getWorkerList(accountId: number, offset = 0, isLoadMore = false) {
        // this.accounts=[];
        this.loadingIndicator = true;
        this._preloader.showPreloader();
        const reqObj = {
            where: {
                Account__c: accountId,
                txtAccountName: this.isVendorWorkerSelected ? this.txtAccountName :''
            },
            limit: this.itemsPerBatch,
            skip: offset
        }
        let listData = [];
        this.workerApi.vendorWorkerList(reqObj).subscribe(res => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
            const workers = res.data;
            this.noRecords = (workers.length < this.itemsPerBatch) ? true : false;
            this.totalCount = res.count ? res.count : 0;
             if (isLoadMore) {
                listData = [...this.tableData, ...workers];
            } else {
                listData = [...workers];
            }
            this.filteredItems = listData.slice();
            if (Object.keys(this.localFilters).length > 0 && this.localFilters.constructor === Object) {
                this.tableData = this.filteredItems.filter(item => {
                    const notMatchingField = Object.keys(this.localFilters).find(key =>
                        this._utilityService.dataTableSearch(item, this.localFilters, key));
                    return !notMatchingField;
                });
            } else {
                this.tableData = listData;
            }
            this.setEmptyMessage();
            this.isVendorWorkerSelected = true;
            // this.setDataTable();
        }, err => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
        })
    }

    selectWorker(row) {     
        const workerSubType = row.Worker_Type_Sub__c ? row.Worker_Type_Sub__c : '';
        row['account'] = {
            CurrencyIsoCode: row.CurrencyIsoCode,
            Default_Pricelist__c: row.Default_Pricelist__c,
            Primary_VCSQDLead_Ref__c: row.Primary_VCSQDLead_Ref__c,
            id: row.account_id,
            Name: row.account_name,
            sfdcId: row.user_account_id,
            accountRFI:{
               Iron_Status__c: row.Iron_Status__c,
               sfdcId: row.Primary_VCSQDLead_Ref__c 
            }
        }
        row['contact'] = {
            Contact_Name__c: row.Contact_Name__c,
            Department: row.Department,
            LastLogin__c: row.LastLogin__c,
            id: row.contact_id,
            ReportsToId: row.ReportsToId,
            Send_RFI_Email__c: row.Send_RFI_Email__c,
            sfdcId: row.Contact__c,
            UserId: row.UserId,
            reportingManagerList: {
                Contact__c: row.Contact__c,
                Name: row.rm_name,
                sfdcId: row.rm_sfdcid
            }
        }

        row['userType'] ={
            slug: row.userTypeSlug,
            name: row.usertype_name,
            id: row.userTypeId
        }

        row['worker'] ={
            sfdcId: row.worker_sfdcid,
            id: row.worker_id,
            Dispatch_Worker_num__c: row.Dispatch_Worker_num__c
        }
        
        this.setVendorView(row);
        this.viewAsVendor = true;
        this.vendorAccessType = {
            viewAsType: this.viewAsTypeName,
            accessType: row.accessType,
            workerType: row.Worker_Type__c,
            workerSubType: workerSubType,
            workerDispatchNumber: row.Dispatch_Worker_num__c,
            userTypeSlug: row.userTypeSlug,
            isMagicLink: row.isMagiclinkTest,
            isNgo: row.isNgo,
            isTest: row.isTest,
            userSfdcId: row.user_sfdcid,
            accountId: row.Account__c,
            workerSfdcId: row.sfdcId,
            firstName: row.firstname,
            lastName: row.lastname,
            userObj: row
        }
        this.vendorAccessType['userObj']['sfdcId'] = row.user_sfdcid;
        this.vendorAccessType['userObj']['id'] = row.user_id;   
        this.vendorAccessType['userObj']['Account_Name__c'] = row.account_name;
        const filterObj = JSON.parse(localStorage.getItem('filterObj'));
        const filterCondition = JSON.parse(localStorage.getItem('filterCondition'));
        filterObj['accounts'] = [row.Account__c];
        localStorage.setItem('filterObj', JSON.stringify(filterObj));
        filterCondition['Vendor__c'] = { inq: [row.Account__c] };
        delete filterCondition['Project_SOP__c'];
        localStorage.setItem('filterCondition', JSON.stringify(filterCondition));
        localStorage.setItem('viewAsInfo', JSON.stringify(this.vendorAccessType));

        this._modalService.closed();
        this.redirectTo(row);
        // window.location.reload();
    }

    showPartnerView(program) {
        this.setViewAsPartnerInfo(program);
        this._modalService.closed();
        window.location.replace(window.location.origin + '/vms');
    }

    csatClose() {
        if (this.surveyData['id']) {
            const reqObj = {
                'id': this.surveyData['id'],
                'workerSfdcId': this.surveyData['workerSfdcId'],
                'wlmsSurveySfdcId': this.surveyData['wlmsSurveySfdcId'],
                'popupDate': this.surveyData['popupDate'],
                'closeButtonClickedDate': new Date()
            }

            this.createOrUpdateSurvey(reqObj,'closed');
        }

        this._modalService.closed();

    }


    trainingClose() {
       // this._modalService.closed();
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    fteSTMClose() {
        this._modalService.closed();

    }

    openCsatSurvey(csatUrl){
        const reqObj = {
            'id': this.surveyData['id'],
            'workerSfdcId': this.surveyData['workerSfdcId'],
            'wlmsSurveySfdcId': this.surveyData['wlmsSurveySfdcId'],
            'popupDate': this.surveyData['popupDate'],
            'surveyLinkClickedDate': new Date()
        }

        this.createOrUpdateSurvey(reqObj,'clicked');
        this._modalService.closed(); 
        window.open(csatUrl, '_blank');
   
    }

    openTrainingLink(trainingUrl){
        this._modalService.closed(); 
        window.open(trainingUrl, '_default');
    }

    setViewAsPartnerInfo(selectedProgram) {
        const viewAsInfo = {
            account: this.partnerInfo,
            program: selectedProgram,
            recordTypeId: this.recordTypeId,
            viewAsType: this.viewAsTypeName,
            isAdmin : this.partnerIsAdmin
        }
        const filterObj = JSON.parse(localStorage.getItem('filterObj'));
        const filterCondition = JSON.parse(localStorage.getItem('filterCondition'));
        filterObj['accounts'] = [viewAsInfo['account']['sfdcId']];
        // delete filterObj['programs'];
        filterObj['programs'] = [viewAsInfo['program']['sfdcId']];
        localStorage.setItem('filterObj', JSON.stringify(filterObj));
        // filterCondition['CKSW_BASE__Account__c'] = { inq: [viewAsInfo['account']['sfdcId']] };
        // delete filterCondition['Project_SOP__c'];
        filterCondition['CKSW_BASE__Account__c'] = { inq: [[viewAsInfo['account']['sfdcId']]]};
        filterCondition['Project_SOP__c'] = { inq: [[viewAsInfo['program']['sfdcId']]]};
        localStorage.setItem('filterCondition', JSON.stringify(filterCondition));
        localStorage.setItem('viewAsInfo', JSON.stringify(viewAsInfo));
    }

    closeVendorView($event) {
        this.setVendorView(null);
        localStorage.removeItem('viewAsInfo');
        window.location.replace(window.location.origin + '');
    }

    async logout() {
        const saveAnalytics = await this.saveAnalytics();
        localStorage.clear();
        this.authService.logout();
    }

    onLogoClick() {
        if (this.accessType === 'partner') {
            this._router.navigate(['/pms']);
        } else if (this.accessType === 'vendor') {
            this._router.navigate(['/vms']);
        } else if (this.accessType === 'internal') {
            if (this.viewType === 'vms') {
                this._router.navigate(['/vms']);
            } else if (this.viewType === 'pms') {
                this._router.navigate(['/pms']);
            }
        }
    }

    open(content, size, src) {
        this.showVendorListing = true;
        this.showWorkerListing= false;
        this.programSelection = false;
        this.txtAccountName = '';
        this.workerTxtAccountName = '';
        this.tableData = [];
        this.workerTableData = [];
        this._modalService.open(content, size);
        if (src === 'viewAsVendor') {
            this.totalWorkerCount = 0;
            this.viewAsTypeName = 'Vendor';
            this.setRecordTypeId('Vendor');
            this.getAllWorkerList();
        } else if (src === 'viewAsPartner') {
            this.viewAsTypeName = 'Partner';
            this.setRecordTypeId('Partner');
        }
    }

    setRecordTypeId(type: string) {
        const filter = {
            where: { and: [{ Name: type }, { SobjectType: 'Account' }] },
            fields: ['sfdcId']
        }
        this._recordType.find(filter).subscribe(res => {
            this.recordTypeId = res[0]['sfdcId'];
            this.getAccount(0, false);
        }, err => { });
    }

    gotToOrderList() {
        if (this._router.url.indexOf('fse-console') === -1) {
            this._router.navigate(['pms/service-manager/fse-console']);
        } else {
            window.location.reload();
        }
    }

    getReleaseNotes() {
        this._releaseNotesApi.getNewCountReleasenotes({}).subscribe(res => {
            this.newCountReleaseNotes = res['count'];
            let today = new Date();
            var differeceinDay = (today.getTime() - new Date(this._commonService.utcDateFormate(res['buildDate'],"MM/DD/YYYY")).getTime())/(1000*3600*24);
            if(differeceinDay <= 3){
                this.showReleaseCounts = true;
            }
        }, err => { })
    }

    goToReleaseNotes() {
        this._router.navigate(['app/release-notes']);
    }

    showJobs(val) {
        const url = '/vms/jobs';
        if (val === 'all') {
            this._router.navigate([url]);
        } else if (val === 'invited') {
            this._router.navigate([url + '/invited']);
        }
    }

    downloadFile() {
        let isOpen = false;
        let filePath = '';
        if (this.accessType === 'internal') {
            filePath = '../../../assets/docs/MSP_User_Manual.pdf';
        } else if (this.accessType === 'partner' && this.userTypeSlug === 'standard') {
            isOpen = true;
            filePath = '../../../assets/docs/Serviceo_PMS_Portal_Manual.pdf';
        } else if (this.accessType === 'partner' && this.userTypeSlug === 'admin') {
            isOpen = true;
            filePath = '../../../assets/docs/Serviceo_PMS_Administrator_Portal_Manual.pdf';
        } else if (this.accessType === 'vendor' && this.userTypeSlug === 'standard') {
            filePath = '../../../assets/docs/VMS_User_Manual.pdf';
        } else if (this.accessType === 'vendor' && this.userTypeSlug === 'admin') {
            isOpen = true;
            filePath = '../../../assets/docs/Serviceo_VMS_Administrator_User_Guide.pdf';
        }

        if (filePath) {
            return this._utilityService.downloadAndOpenPdfFile(filePath, 'ServiceO-User Manual.pdf', isOpen);
        } else {
            alert('Help document not found !!');
        }
    }

    getAccount(offset: number, isLoadMore = false) {
        this.accountNameLabel='';
        this.isVendorWorkerSelected = false;
        this.programSelection = false;
        this.loadingIndicator = true;
        this._preloader.showPreloader();
        //vendorAccountApi
        const reqObj = {
            where: {
                RecordTypeId: this.recordTypeId,
                txtAccountName: this.txtAccountName
            },
            limit: this.itemsPerBatch,
            skip: offset
        }
        let listData = [];
        this.workerApi.vendorAccountApi(reqObj).subscribe(res => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
            const accounts = res.data;
            this.noRecords = (accounts.length < this.itemsPerBatch) ? true : false;
            this.totalCount = res.count ? res.count : 0;
            if (isLoadMore) {
                listData = [...this.tableData, ...accounts];
            } else {
                listData = [...accounts];
            }
            this.filteredItems = listData.slice();
            if (Object.keys(this.localFilters).length > 0 && this.localFilters.constructor === Object) {
                this.tableData = this.filteredItems.filter(item => {
                    const notMatchingField = Object.keys(this.localFilters).find(key =>
                        this._utilityService.dataTableSearch(item, this.localFilters, key));
                    return !notMatchingField;
                });
            } else {
                this.tableData = listData;
            }
            this.setEmptyMessage();
        }, err => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
        });


        // this.accountApi.find({
        //     fields: ['id', 'sfdcId', 'Name', 'Company_Reference_code__c', 'Service_Global_Ref__c', 'CreatedById'],
        //     include: ['users'],
        //     limit: this.itemsPerBatch,
        //     where: this.txtAccountName ? { Name: { 'ilike': '%' + this.txtAccountName + '%' }, RecordTypeId: this.recordTypeId } :
        //         { Name: { 'neq': this.txtAccountName }, RecordTypeId: this.recordTypeId },
        //     skip: offset
        // }).subscribe(accounts => {
        //     this.noRecords = (accounts.length < this.itemsPerBatch) ? true : false;
        //     if (!isLoadMore) {
        //         this.accounts = accounts;
        //     } else {
        //         accounts.forEach(c => {
        //             this.accounts.push(c);
        //         });
        //         this.accounts = [...this.accounts];
        //     }
        //     this.setDataTable();
        // }, err => {
        //     this.loadingIndicator = false;
        //     this._preloader.hidePreloader();
        // })
    }

    loadMoreRecords() {
        if(this.isVendorWorkerSelected){
            this.getWorkerList(this.accountSfcdId, this.filteredItems.length, true);
        }
        else if (this.programSelection) {
            this.getProgramList(this.filteredItems.length, true);
        } else {
            this.getAccount(this.filteredItems.length, true);
        }
    }

    setDataTable() {
        let targettedData = this.isVendorWorkerSelected ? this.workersList : this.accounts;
        if (this.txtAccountName) {
            const val = this.txtAccountName.toLowerCase();
            this.tableData = targettedData.filter(function (d) {
                return d.Name.toLowerCase().indexOf(val) !== -1 || !val;
            });
        } else {
            this.tableData = targettedData;
        }
        this.loadingIndicator = false;
        this._preloader.hidePreloader();
    }

    selectPartner(partnerObj, offset: number) {
        console.log('Selected Partner:', partnerObj);
        this.accountNameLabel = partnerObj['Name'];
        this.partnerInfo = partnerObj;
        this.getProgramList(0, false)
    }

    getProgramList(offset: number, isLoadMore = false) {
        //vendorProgramApi
        const reqObj = {
            where: {
                RecordTypeId: '0121a0000006QJJAA2',
                txtAccountName: this.txtAccountName,
                Account__c: this.partnerInfo['sfdcId']
            },
            limit: this.itemsPerBatch,
            skip: offset
        }
        let listData = [];
        this.workerApi.vendorProgramApi(reqObj).subscribe(res => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
            const programs = res.data;
            this.noRecords = (programs.length < this.itemsPerBatch) ? true : false;
            this.totalCount = res.count ? res.count : 0;
            if (isLoadMore) {
                listData = [...this.tableData, ...programs];
            } else {
                listData = [...programs];
            }
            this.filteredItems = listData.slice();
            if (Object.keys(this.localFilters).length > 0 && this.localFilters.constructor === Object) {
                this.tableData = this.filteredItems.filter(item => {
                    const notMatchingField = Object.keys(this.localFilters).find(key =>
                        this._utilityService.dataTableSearch(item, this.localFilters, key));
                    return !notMatchingField;
                });
            } else {
                this.tableData = listData;
            }
            this.programSelection = true;
            this.setEmptyMessage();
        }, err => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
        });
//
        // const filter = {
        //     where: this.txtAccountName ? { Name: { 'ilike': '%' + this.txtAccountName + '%' }, Account__c: this.partnerInfo['sfdcId'], RecordTypeId: '0121a0000006QJJAA2' } :
        //         { Name: { 'neq': this.txtAccountName }, Account__c: this.partnerInfo['sfdcId'], RecordTypeId: '0121a0000006QJJAA2' },
        //     fields: ['id', 'sfdcId', 'Name', 'Project__c'],
        //     limit: this.itemsPerBatch,
        //     skip: offset
        // };

        // this._projectApi.find(filter).subscribe(accounts => {
        //     this.programSelection = true;
        //     this.noRecords = (accounts.length < this.itemsPerBatch) ? true : false;
        //     if (!isLoadMore) {
        //         this.accounts = accounts;
        //     } else {
        //         this.accounts = [...this.accounts, ...accounts];
        //     }
        //     this.setDataTable();
        // }, err => { });
    }

    exitViewAsMode() {
        localStorage.removeItem('viewAsInfo');
        const filterObj = JSON.parse(localStorage.getItem('filterObj'));
        const filterCondition = JSON.parse(localStorage.getItem('filterCondition'));
        delete filterObj['accounts'];
        delete filterObj['programs']
        localStorage.setItem('filterObj', JSON.stringify(filterObj));
        delete filterCondition['CKSW_BASE__Account__c'];
        delete filterCondition['Project_SOP__c'];
        localStorage.setItem('filterCondition', JSON.stringify(filterCondition));
        window.location.replace(window.location.origin + '');
    }

    
    selectToPartnerList() {
        if (this.isVendorWorkerSelected) {
            this.isVendorWorkerSelected = false;
            this.viewAsTypeName = 'Vendor';
            this.setRecordTypeId('Vendor');
        } else {
            this.programSelection = false;
            this.viewAsTypeName = 'Partner';
            this.setRecordTypeId('Partner');
        }
        this.txtAccountName = '';
        this.tableData = [];
    }

    async saveAnalytics() {
        return new Promise((resolve, reject) => {
            this._commonService.saveCurrentPageAnalytics('', '', resolve)
        })
    }

        // to show uploaded image in left panel and heder bar
        pictureUploaded(event) {
            this.user.picture = event.picture;
            this.user.profileImage = event.profileImage;
            this.commonService.setUserProfile(this.user);
        }
    
    redirectTo(row) {
        if ((row && row.user && row.user.contact && row.user.contact.Send_RFI_Email__c == true &&
            row.user.userType && row.user.userType.slug === 'admin') && (row.user.account &&
                row.user.account.Primary_VCSQDLead_Ref__c === null || row.user.account.accountRFI &&
                row.user.account.accountRFI.Iron_Status__c != 'Approved')) {
            window.location.replace(window.location.origin + '/vms/vms-billing-manager?activeId=accountProfile');
        } else if (row && row.user && row.user.userType && row.user.userType.slug !== 'admin' && row.Worker_Type__c.includes('FTE')) {
            window.location.replace(window.location.origin + '/app/workforce-checkin-checkout');
        } else {
            window.location.replace(window.location.origin + '/vms');
        }
    }
    createHelpDeskTask() {
        this._modalService.open(this.createTaskModal, 'xl modal-create-hd-task');
    }   

    closeHTpopup(e){
       if(e === true){
        const closeHTPopupBtn = document.getElementById("closeHTPopupBtn");
        closeHTPopupBtn.click();
       }
    }

     createFeedback() {
        this._modalService.open(this.createFeedbackModal, 'xl modal-create-hd-task');
    }

    closeFeedbackpopup(e){
       if(e === true){
        const closeHTPopupBtn = document.getElementById("closeFeedbackPopupBtn");
        closeHTPopupBtn.click();
       }
    }

    checkPartnerIsAdmin(checked) {
        if (checked) {
            this.partnerIsAdmin = true;
        } else {
            this.partnerIsAdmin = false;
        }
      }

      initWorkerSearch() {
        const observable = this.workerKeyUp
            .map(value => value['target']['value'].toLowerCase())
            .debounceTime(300)
            // .distinctUntilChanged()
            .flatMap((search) => {
                return Observable.of(search).delay(300);
            })
            .subscribe((data) => {
                this.getAllWorkerList(0, false);
            });
    }

    showVendorSection(){
        this.showVendorListing = true;
        this.showWorkerListing = false;
    }

    showWorkerSection(){
        this.showWorkerListing = true;
        this.showVendorListing = false;
    }

    getAllWorkerList(offset = 0, isLoadMore = false){
        let searchWorkerCondition = [];
        let workerId = null;
        if(this.workerTxtAccountName) {
            const regex = /(W00)|(@)|(WI)/g;
            this.workerIDOrEmail = this.workerTxtAccountName.match(regex);
            // searchWorkerCondition = [{'firstname': {'like': '%' + this.workerTxtAccountName + '%' }}, {'lastname': {'like': '%' + this.workerTxtAccountName + '%' } }] DUVÁN GABRIEL OSOY MONTERROSO
            let splittedWorkerName = this.workerTxtAccountName.split(" "); 
            splittedWorkerName.forEach(function (value) {
                if(value.length > 0){
                    let firstNameCondition = {'firstname': {'ilike': '%' + value + '%' }};
                    searchWorkerCondition.push(firstNameCondition);
                    let lastNameCondition = {'lastname': {'ilike': '%' + value + '%' }};
                    searchWorkerCondition.push(lastNameCondition);
                }
            });
            if (this.workerTxtAccountName && this.workerIDOrEmail && this.workerIDOrEmail.length > 0) {
                let email = { "email": { 'ilike': '%' + this.workerTxtAccountName + '%' } };
                searchWorkerCondition.push(email);
            }

            if (this.workerTxtAccountName) {
                const input = this.workerTxtAccountName.trim();
                // if input looks like a worker id (W00...) or an email, treat as a single token
                if (/W00/i.test(input) || input.indexOf('@') !== -1) {
                    workerId = input
                }
            }
            
                    
        }
        this.loadingIndicator = true;
        this._preloader.showPreloader();
        this._usersApi.find({
            fields: ['id', 'sfdcId', 'accessType', 'userType', 'userTypeId', 'isTest', 'isMagiclinkTest', 'isNgo', 'firstname', 'lastname', 'AccountId','WorkerSfdcId'],
            include: [ 
                {
                    relation: 'workers',
                    scope: {
                        fields: ['id', 'sfdcId', 'Name', 'Dispatch_Worker_num__c', 'Email__c', 'Contact__c', 'Account__c', 'Account_Name__c', 'Worker_Type__c','Worker_Type_Sub__c'],
                        where: this.workerTxtAccountName && this.workerIDOrEmail && this.workerIDOrEmail.length > 0  && workerId ?
                        {
                            and: [
                                { "sfdcId": { neq: null } },
                                { or: [{ "Dispatch_Worker_num__c":{'ilike': '%'+this.workerTxtAccountName+'%' }}, { "Email__c": {'ilike': '%'+this.workerTxtAccountName+'%' }}] },
                            ]
                        } : { "sfdcId": { neq: null } },
                    }
                },
                {
                    relation: 'userType',
                    scope: {
                        fields: ['name', 'slug']
                    }
                },
                {
                    relation: 'account',
                    scope: {
                        fields: ['id', 'Name', 'Primary_VCSQDLead_Ref__c', 'Default_Pricelist__c', 'CurrencyIsoCode'],
                        include: [{
                            relation: 'accountRFI',
                            scope: {
                                fields: ['Iron_Status__c']
                            }
                        }]
                    }
                },
                {
                    relation: 'contact',
                    scope: {
                        fields: ['id', 'Send_RFI_Email__c', 'UserId', 'LastLogin__c', 'ReportsToId', 'Contact_Name__c', 'Department'],
                        include: [{
                            relation: 'reportingManagerList',
                            scope: {
                                fields: ['sfdcId', 'Name']
                            }
                        }]
                    }
                }
            ],
            order: 'firstname', 
            limit: this.itemsPerBatch,
            where: this.workerTxtAccountName && !workerId ? {and: [{"accessType": 'vendor',"sfdcId": { neq: null }}, {or: searchWorkerCondition} ]} : {"accessType": 'vendor',"sfdcId": { neq: null }},
            skip: offset
        }).subscribe(workers => {
            this.totalWorkerCount += workers.length;
            this.noRecords = (workers.length < this.itemsPerBatch) ? true : false;
            let tempWorkers = [];
            workers.forEach(el=>{
                if(el['workers'] && el['workers'].length && el['workers'][0] && el['workers'][0]['sfdcId']) {
                    el['worker'] = el['workers'][0];
                    el['worker']['userTypeSlug'] = el['userType'] ? el['userType']['slug'] : null;
                    delete el['workers'];
                    tempWorkers.push(el);
                }
            })
            workers = [...tempWorkers];

            //workers = workers.filter((item: any) => item && item.worker && item.sfdcId);
            //console.log(workers.length)
            if (!isLoadMore) {
                this.allWorkersList = workers;
            } else {
                workers.forEach(c => {
                    this.allWorkersList.push(c);
                });
                this.allWorkersList = [...this.allWorkersList];
            }
            
            this.workerSetDataTable();
        }, err => {
            this.loadingIndicator = false;
            this._preloader.hidePreloader();
        })
    }

    workerSetDataTable() {
        let targettedData = this.allWorkersList; //this.isVendorWorkerSelected ? this.allWorkersList : this.accounts;
        if (this.workerTxtAccountName && this.workerIDOrEmail==null) {
            const val = this.workerTxtAccountName.toLowerCase();
            this.workerTableData = targettedData.filter(function (d) {
                return d.worker.Name.toLowerCase().indexOf(val) !== -1 || !val;
            });
        } else {
            this.workerTableData = targettedData;
        }
        this.loadingIndicator = false;
        this._preloader.hidePreloader();
    }
    
    setVendorWorkerView(vendor) {
        this.vendor = vendor;
        if (vendor) {
            localStorage.setItem('ImpersonationId', vendor['WorkerSfdcId']);
        } else {
            localStorage.removeItem('ImpersonationId');
        }
        this._appState.setNavAsVendor(this.vendor);
    }

    selectWorkerDetail(row) { 
        this.setVendorWorkerView(row);
        let workerProcessRow = {};
        let userRow = {};
        userRow = {user: row};
        workerProcessRow = row.worker;
        let processRow = {...workerProcessRow, ...userRow,...userRow['user']};
        this.vendorAccessType = {
            viewAsType: this.viewAsTypeName,
            accessType: row['accessType'],
            workerType: row.worker['Worker_Type__c'],
            userTypeSlug: row.userType.slug,
            isMagicLink: row.isMagiclinkTest,
            isNgo: row.isNgo,
            isTest: row.isTest,
            userSfdcId: row.sfdcId,
            accountId: row.worker['Account__c'],
            workerSfdcId: row.WorkerSfdcId,
            firstName: row.firstname,
            lastName: row.lastname,
            userObj: processRow,
        }
        const filterObj = JSON.parse(localStorage.getItem('filterObj'));
        const filterCondition = JSON.parse(localStorage.getItem('filterCondition'));
        filterObj['accounts'] = [row.worker['Account__c']];
        localStorage.setItem('filterObj', JSON.stringify(filterObj));
        filterCondition['Vendor__c'] = { inq: [row.worker['Account__c']] };
        delete filterCondition['Project_SOP__c'];
        localStorage.setItem('filterCondition', JSON.stringify(filterCondition));
        localStorage.setItem('viewAsInfo', JSON.stringify(this.vendorAccessType));

        this._modalService.closed();
        this.redirectToWorkerAccount(row);
    }

    redirectToWorkerAccount(row) {
        if ((row && row.contact && row.contact.Send_RFI_Email__c == true &&
            row.userType && row.userType.slug === 'admin') && (row.account &&
                row.account.Primary_VCSQDLead_Ref__c === null || row.account.accountRFI &&
                row.account.accountRFI.Iron_Status__c != 'Approved')) {
            window.location.replace(window.location.origin + '/vms/vms-billing-manager?activeId=accountProfile');
        } else if (row && row.userType && row.userType.slug !== 'admin' && row.worker.Worker_Type__c.includes('FTE')) {
            window.location.replace(window.location.origin + '/app/workforce-checkin-checkout');
        } else {
            window.location.replace(window.location.origin + '/vms');
        }
    }

    loadMoreWorkerRecords() {
        this.getAllWorkerList(this.totalWorkerCount, true);
    }

    openmodel(template) {
        this._modalService.open(template, { size: 'sm modal-clone-milestone', backdrop: 'static', keyboard: false });
    }

    setEmptyMessage() {
    const msg = 'No data to display.';
    if (!this.tableData.length) {
      this.tableData = [{
        'message': msg
      }];
      this.tableData[0]['Name'] = msg;
      //this.tableColumns[0]['width'] = 160;
    } else {
      if (this.tableData[0].hasOwnProperty('message')) {
        this.tableData.shift();
      }
      //this.tableColumns[0]['width'] = 200;
    }
  }
    
checkProfileSettingPreferencesPopup() {
    axios.get(environment.baseUrl + '/api/content/user-preferences-consent').then((res: any) => {
        console.log(res.data.showConsentModal)
        if (res.data && String(res.data.showConsentModal) === "true") {            
            this.showConsentModal = true;
            this.openUserPreferenceModal();
        }else{
            this.showConsentModal = false;
        }
        console.log(this.showConsentModal)
        localStorage.setItem('showConsentForm',this.showConsentModal ? 'Yes':'No')
    });

}

openUserPreferenceModal() {
    this.modalRef = this._modalService.open(this.userPreferencesModel, { size: 'lg' });
}

closeUserPreferenceModal(e) {
    if (e === true) {
        localStorage.setItem('userPreferenceModalDismissed', 'true');
        const closeHTPopupBtn = document.getElementById("closeUserPreferencePopupBtn");
        if(closeHTPopupBtn) {
            closeHTPopupBtn.click();
        }
    }
}

messageNotificationCount() {
        this.subscription = this._messageNotificationSocketService.getMessageNotificationCount().subscribe(
            unreadNotification => {
                this.notification = unreadNotification;
                this._faviconBadgeService.setCount(unreadNotification );
            }
        );
    }
}
